import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import CustomInput from '../Utility/Components/CustomInput';
import ErrorBoundary from '../Utility/Components/ErrorBoundary';
import CustomButton from '../Utility/Components/CustomButton';
import ModalGlobal from '../Utility/Components/ModalGlobal';
import RoleAddEditModalContent from './Components/RoleAddEditModalContent'
import { roleCreate, roleList, roleStatusUpdate, roleDelete, getHotelBranchList, getStoreList, getStoreDetails } from './Controller/RoleController';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../Actions/AllAction';
import { getDefaultRoleData } from "../Utility/POS_role.js";
import { connect } from 'react-redux';
import Utility from '../Utility/Utility';
import GridActionContent from '../Utility/Components/GridActionContent';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import ConfirmationAlert from '../Utility/Components/ConfirmationAlert';
import AutosuggestComponent from '../Utility/Components/AutosuggestComponent';
import { DebounceInput } from 'react-debounce-input';
import CustomNoRowsOverlay from '../Utility/Components/CustomNoRowsOverlay'
import ReactTooltip from 'react-tooltip';
import RefreshButton from '../Utility/Components/RefreshButton'
import IsEligibleToShow from '../Utility/Components/IsEligibleToShow';

function Role(props) {
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        minWidth: 50

    });

    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    })

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridparams, setgridparams] = useState(null);

    //======= add action permission ====//
    // Check multiple permissions at once
    const rolePermissions = Utility.hasMultipleActionPermissions(
        'user_and_customer',
        'roles',
        ['view', 'create', 'edit', 'delete', 'change_status', 'manage_permissions'],
        props.userCredentials?.user_details?.user_type || ['admin', 'app_admin']
    );

    // Check if any actions are available for display in the table
    const hamburgerTableActions = rolePermissions.view || rolePermissions.edit || rolePermissions.delete || rolePermissions.change_status || rolePermissions.manage_permissions;


    const [columnDefs, setColumnDefs] = useState(
        [
            {
                headerName: 'Name',
                field: "name",
                minWidth: 500,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.name && params.data.name.length > 30) {
                            return <div><span className="textrenderview">
                                <OverlayTrigger overlay={<Tooltip>{params.data.name}</Tooltip>}>
                                    <span>{(params.data.name).substring(0, 30) + "..."}</span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return <div><span className="textnowrapview">{params.data.name}</span></div>
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Store Name',
                field: "branch_name",
                minWidth: 500,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('RoleBranchRelation') && params.data.RoleBranchRelation) {
                            if (params.data.RoleBranchRelation.hasOwnProperty('name') && params.data.RoleBranchRelation.name != "" && params.data.RoleBranchRelation.name.length > 30) {
                                return <div>
                                    <OverlayTrigger overlay={<Tooltip>{params.data.RoleBranchRelation.name}</Tooltip>}>
                                        <span>{(params.data.RoleBranchRelation.name).substring(0, 30) + "..."}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div>{params.data.RoleBranchRelation.name}</div>
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: "",
                field: "status",
                minWidth: 200,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params && rolePermissions.change_status) {
                        if (params.data) {
                            let userRoleId = props.userCredentials.hasOwnProperty('user_details') && props.userCredentials.user_details.hasOwnProperty('role_id') ? props.userCredentials.user_details.role_id : ""
                            let userType = props.userCredentials.hasOwnProperty('user_details') && props.userCredentials.user_details.hasOwnProperty('user_type') ? props.userCredentials.user_details.user_type : ""
                            let visitorId = params.hasOwnProperty('data') && params.data.hasOwnProperty('id') && params.data.id
                            return <button className="edittext">
                                <div className="switch_btn_customize_box">
                                    {Utility.userWisePermission(userRoleId, visitorId, userType) ?
                                        <BootstrapSwitchButton checked={params.data && params.data.is_active ? params.data.is_active : false} onChange={handleChangeSwitchButton.bind(this, params.data)} disabled={
                                            (() => {
                                                const roleObj = Utility.getRoleObjectByEventKey('user_and_customer');
                                                if (roleObj && roleObj.subeventKey && roleObj.subeventKey.length > 0) {
                                                    const rolesSubEvent = roleObj.subeventKey.find(item => item.eventKey === 'roles');
                                                    return rolesSubEvent && (rolesSubEvent.rules === "CRUD" || rolesSubEvent.rules === "CUD") ? false : true;
                                                }
                                                return true;
                                            })()
                                        }
                                            onlabel='Active'
                                            onstyle='success'
                                            offlabel='Inactive'
                                            offstyle='danger'
                                            style='w-100 mx-3'
                                        />
                                        : null}
                                </div>
                            </button>
                        } else {
                            return null
                        }
                    } else {
                        return null
                    }
                },
            },
            {
                headerName: "",
                field: "edit",
                width: 90,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        let userRoleId = props.userCredentials.hasOwnProperty('user_details') && props.userCredentials.user_details.hasOwnProperty('role_id') ? props.userCredentials.user_details.role_id : ""
                        let userType = props.userCredentials.hasOwnProperty('user_details') && props.userCredentials.user_details.hasOwnProperty('user_type') ? props.userCredentials.user_details.user_type : ""
                        let visitorId = params.hasOwnProperty('data') && params.data.hasOwnProperty('id') && params.data.id

                        let rolePermission = Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0 && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].eventKey == "roles" && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].rules == "CUD"))
                        return <div className="actionablePopupBox">
                            {Utility.userWisePermission(userRoleId, visitorId, userType) && hamburgerTableActions ?
                                <>
                                    {rolePermission && <button className="ellipsisIcon" onClick={(e) => actionModalfunction(e, params)}><i className="fa fa-ellipsis-v"></i></button>}
                                </>
                                : null}
                        </div>
                    } else {
                        return null;
                    }
                },
            }

        ]
    )



    const actionOutsideClickRef = useRef();
    const [searchUserName, setSearchUserName] = useState("");
    const [actionModalflag, setActionModalflag] = useState(false);
    const [overlayHight, setOverlayHight] = useState(0);
    const [overlayWidth, setOverlayWidth] = useState(0);
    const [gridObjData, setGridObjData] = useState({});
    const [roleCreateModalFlag, setroleCreateModalFlag] = useState(false);
    const [editedFlag, setEditedFlag] = useState(false);
    const [editedId, setEditedId] = useState("");
    const [roleName, setRoleName] = useState("");
    const [roleNameError, setRoleNameError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [statusList, setStatusList] = useState([
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ]);
    const [roleRawData, setroleRawData] = useState(getDefaultRoleData(props.currentStore));
    const [deleteRoleModalFlag, setDeleteRoleModalFlag] = useState(false);
    const [roleDeleteBodySecondContent, setRoleDeleteBodySecondContent] = useState("");
    const [roleDeleteObj, setRoleDeleteObj] = useState({});
    const [roleCount, setRoleCount] = useState("");
    const [selectedBranch, setSelectedBranch] = useState({});
    const [branchList, setBranchList] = useState([]);
    const [branchNameError, setBranchNameError] = useState("");
    const [zoominzoomoutflag, setZoominzoomoutflag] = useState("");
    const [searchRole, setSearchRole] = useState("");

    const [hotelBranchFilterSelectedValue, setHotelBranchFilterSelectedValue] = useState("");
    const [branchFilterList, setBranchFilterList] = useState([]);
    let roleRef = useRef(true);
    const gridRef = useRef();
    const [isAnimating, setIsAnimating] = useState(true);
    const [storeData, setStoreData] = useState(props.currentStore);

    const onGridReady = useCallback((params) => {
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    //reset role grid fn
    const resetDataGrid = () => {
        var datasource = serverSideDataSource()
        gridApi.setDatasource(datasource);
    }

    //create role modal open fn 
    const createRoleModalFn = () => {
        setroleCreateModalFlag(true);
    }

    //close role modal fn
    const closeRoleModal = () => {
        setroleCreateModalFlag(false);
        setEditedFlag(false)
        setEditedId("")
        resetRoleFn()
        setZoominzoomoutflag("");
    }

    //get hotel branch list api called when role modal open
    useEffect(() => {
        if (roleCreateModalFlag) {
            getHotelBranchListApi();
        }
    }, [roleCreateModalFlag])

    const getChangedBranchDetails = (selectedSlack) => {
        // console.log("selected branch in getChangedBranchDetails function is", selectedSlack)
        getStoreDetails(selectedSlack).then((response) => {
            // console.log("store details response in getChangedBranchDetails function is", response.data)
            // setroleRawData(response.data);
            setStoreData(response.data);
        }).catch((error) => {
            console.error("Error fetching store details:", error);
        });

        // setStoreData(response);
    }
    useEffect(() => {
        // console.log("selected branch in useeffect is", selectedBranch)
        if (selectedBranch && selectedBranch.slack) {
            let selectedBranchDetails = branchList.find(branch => branch.value === selectedBranch.value);
            // console.log("selected branch details in useeffect is", selectedBranchDetails)
            getChangedBranchDetails(selectedBranchDetails?.slack);
        }
    }, [selectedBranch])

    //get hotel branch list api fn 
    const getHotelBranchListApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        // let data = { "is_active": true };
        let filter = {}
        // filter['filters'] = JSON.stringify(data);
        loaderStateTrue();
        getHotelBranchList(filter).then((response) => {
            let hotelBranchResponse = Object.keys(response.data).length > 0 && response.data[Object.keys(response.data)[0]]?.OrgBranchOrgRelation.length > 0 ? response.data[Object.keys(response.data)[0]].OrgBranchOrgRelation : {}
            let branchList = [];
            let branchListObj = {};
            hotelBranchResponse.map((e) => {
                branchListObj = {};
                // branchListObj['label'] = `${e.branch_name}`;
                branchListObj['label'] = `${e.name}`;
                branchListObj['value'] = e.id;
                branchListObj['slack'] = e.slack;
                branchList.push(branchListObj)
            })
            if (branchList.length > 0) {
                setBranchList(branchList);
                // console.log("Branch List for Role Modal:",props.currentStore?.id);
                // Only set current branch as default in create mode, not in edit mode
                if (!editedFlag) {
                    const currentBranch = branchList.find(
                        branch => branch.value === props.currentStore?.id
                    );

                    if (currentBranch) {
                        setSelectedBranch(currentBranch);
                    }
                }
            }

            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();

        });
    }

    //after getting branch list edit mode dataset create
    useEffect(() => {
        if (editedFlag) {
            setEditDataset();
        }
    }, [branchList])

    //role modal reset fn
    const resetRoleFn = () => {
        setRoleName("");
        setRoleNameError("");
        setBranchList([]);
        setSelectedBranch({});
        setBranchNameError("");
        setroleRawData(getDefaultRoleData(props.currentStore));
        setZoominzoomoutflag("");
    }

    //get role list api fn
    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse } = props;
                setIsAnimating(true);
                loaderStateTrue();
                let filters = {};
                let filter_op = {};
                let globalQueryParamshash = {};
                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);

                if (searchRole != "") {
                    globalQueryParamshash['name'] = searchRole
                    filter_op = Object.assign(filter_op, { "name": "substring" });
                }

                if (sortModel.length > 0) {
                    const statusSortExists = sortModel.some(item => item.sort === "desc" || "asc" && item.colId === "status");
                    if (!statusSortExists) {
                        sortModel.push({ "sort": "desc", "colId": "status" });
                    }
                    globalQueryParamshash['sorting'] = sortModel;
                } else {
                    globalQueryParamshash['sorting'] = [{ "sort": "desc", "colId": "status" }, { "sort": "asc", "colId": "name" }];
                }


                if (selectedStatus != "") {
                    globalQueryParamshash['is_active'] = selectedStatus.value == "active" ? true : false;
                }
                if (hotelBranchFilterSelectedValue && hotelBranchFilterSelectedValue != "") {
                    globalQueryParamshash['branch_id'] = hotelBranchFilterSelectedValue.value
                }
                if (Object.keys(filter_op).length > 0) {
                    filters["filter_op"] = JSON.stringify(filter_op);
                }
                filters['filters'] = JSON.stringify(globalQueryParamshash)
                let filterServerside = Object.keys(JSON.parse(filters.filters)).length > 0 ? filters : null
                roleList(filterServerside).then((response) => {
                    if (response.success) {
                        if (response.data.length == 0 && startRow == 0) {
                            gridRef.current.api.showNoRowsOverlay();
                        } else {
                            gridRef.current.api.hideOverlay();
                        }
                        params.successCallback(response.data, response.total);
                        setRoleCount(response.total)
                    } else {
                        params.failCallback();
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                    }
                    loaderStateFalse();
                    setIsAnimating(false);
                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                    }
                    loaderStateFalse();
                    setIsAnimating(false);
                    if (error.message == "Network Error") {

                    }
                });
            }
        };
    }

    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,
        }),
        []
    )

    //role active inactive switch button onchange api fn 
    const handleChangeSwitchButton = (data) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let dataHash = {};
        let id = data.id
        dataHash["is_active"] = !data.is_active;
        loaderStateTrue()
        roleStatusUpdate(id, dataHash).then((response) => {
            loaderStateFalse()
            if (response.success) {
                gridOptions.api.purgeInfiniteCache();
                resetDataGrid();
                Utility.toastNotifications(response.message, "Success", "success");

            } else {
                gridOptions.api.purgeInfiniteCache();
                resetDataGrid();
                Utility.toastNotifications(response.message, "Error", "error");

            }
        }).catch((error) => {
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });
    }

    //initially action modal close
    useEffect(() => {
        const handleMouseDown = (event) => {
            handleClickOutside(event);
        };
        document.body.addEventListener('mousedown', handleMouseDown);

        return () => {
            document.body.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    //when click on hamburger menu action modal open
    const actionModalfunction = (e, gridObj) => {
        e.stopPropagation();
        let width = (parseInt(e.clientX) - 200) + 'px';
        let height = (parseInt(e.clientY) - 60) + 'px';
        setActionModalflag(true);
        setOverlayHight(height);
        setOverlayWidth(width);
        setGridObjData(gridObj);
    }

    //outside click action modal close
    const handleClickOutside = (event) => {
        if (actionOutsideClickRef.current && !actionOutsideClickRef.current.contains(event.target)) {
            setActionModalflag(false);
            setOverlayHight(0);
            setOverlayWidth(0);
            setGridObjData({});
        }
    };

    //edit role fn
    const editRoleManagePermissionFn = (params) => {
        if (params.data?.hasOwnProperty('is_active') && params.data?.is_active) {
            setroleCreateModalFlag(true);
            setEditedFlag(true)
            setEditedId(params.data.id)
        } else {
            Utility.toastNotifications("This role's current status is inactive. Alter this role's status if you wish to make any changes to it.", "Warning", "warning")
        }

    }

    //role edit dataset ready
    const setEditDataset = () => {
        let gridData = gridObjData.data;
        if (gridData.hasOwnProperty("name") && gridData.name != null) {
            setRoleName(gridData.name)
        } else {
            setRoleName("")
        }
        if (gridData.hasOwnProperty("role_json") && gridData.role_json != null) {
            setroleRawData(transformPermissions(roleRawData, JSON.parse(gridData.role_json)))
        }
        if (gridData.hasOwnProperty("branch_id") && gridData.branch_id != null) {
            let findBranch = branchList.find(branch => branch.value === gridData.branch_id);
            if (findBranch != undefined) {
                setSelectedBranch(findBranch)
            }
        }
    }

    //role dataset formatting when edit mode role modal open
    const transformPermissions = (originalPermissions, newPermissions) => {
        if (typeof newPermissions === "string") {
            try {
                newPermissions = JSON.parse(newPermissions);
            } catch (e) {
                console.error("Invalid newPermissions JSON:", e);
                newPermissions = [];
            }
        }

        if (!Array.isArray(newPermissions)) {
            newPermissions = [];
        }

        let mergedPermissions = [];
        originalPermissions.forEach(originalEvent => {
            let matchingNewEvent = newPermissions?.find(newEvent => newEvent.eventKey === originalEvent.eventKey);

            if (matchingNewEvent) {
                let mergedEvent = {
                    eventKey: originalEvent.eventKey,
                    crud: matchingNewEvent.rules.includes('C') && matchingNewEvent.rules.includes('R') && matchingNewEvent.rules.includes('U') && matchingNewEvent.rules.includes('D') ? true : originalEvent.crud,
                    read: matchingNewEvent.rules.includes('R') ? true : originalEvent.read,
                    write: matchingNewEvent.rules.includes('C') && matchingNewEvent.rules.includes('U') && matchingNewEvent.rules.includes('D') ? true : originalEvent.write
                };

                if (originalEvent.subeventKey && matchingNewEvent.subeventKey) {
                    mergedEvent.subeventKey = originalEvent.subeventKey.map(originalSubevent => {
                        let matchingNewSubevent = matchingNewEvent.subeventKey.find(subevent => subevent.eventKey === originalSubevent.eventKey);
                        if (matchingNewSubevent) {
                            let mergedSubevent = {
                                eventKey: originalSubevent.eventKey,
                                crud: matchingNewSubevent.rules.includes('C') && matchingNewSubevent.rules.includes('R') && matchingNewSubevent.rules.includes('U') && matchingNewSubevent.rules.includes('D') ? true : originalSubevent.crud,
                                read: matchingNewSubevent.rules.includes('R') ? true : originalSubevent.read,
                                write: matchingNewSubevent.rules.includes('C') && matchingNewSubevent.rules.includes('U') && matchingNewSubevent.rules.includes('D') ? true : originalSubevent.write
                            };

                            // Handle actions for all subeventKeys
                            if (originalSubevent.actions) {
                                mergedSubevent.actions = { ...originalSubevent.actions };

                                // Check if saved actions exist and have at least one true value
                                const hasSavedActions = matchingNewSubevent.actions &&
                                    typeof matchingNewSubevent.actions === 'object' &&
                                    Object.keys(matchingNewSubevent.actions).length > 0 &&
                                    Object.values(matchingNewSubevent.actions).some(val => val === true);

                                if (hasSavedActions) {
                                    // Update actions from saved data if available
                                    Object.keys(matchingNewSubevent.actions).forEach(actionKey => {
                                        if (mergedSubevent.actions.hasOwnProperty(actionKey)) {
                                            mergedSubevent.actions[actionKey] = matchingNewSubevent.actions[actionKey];
                                        }
                                    });
                                } else {
                                    // Auto-select all actions if crud or write is true in edit mode ONLY if no saved actions exist
                                    if (mergedSubevent['crud'] || mergedSubevent['write']) {
                                        Object.keys(mergedSubevent.actions).forEach(actionKey => {
                                            if (typeof mergedSubevent.actions[actionKey] === 'boolean') {
                                                mergedSubevent.actions[actionKey] = true;
                                            }
                                        });
                                    }
                                }
                            }

                            return mergedSubevent;
                        } else {
                            return originalSubevent;
                        }
                    });
                }

                mergedPermissions.push(mergedEvent);
            } else {
                mergedPermissions.push(originalEvent);
            }
        });

        return mergedPermissions;
    };

    //delete role confirmation modal open fn
    const deleteRole = (params) => {
        setDeleteRoleModalFlag(true);
        setRoleDeleteBodySecondContent(params.data.name)
        setRoleDeleteObj(params.data)
    }

    //delete role confirmation modal close fn
    const deleteRoleConfirmationModalHide = () => {
        setDeleteRoleModalFlag(false);
        setRoleDeleteBodySecondContent("")
    }

    //delete role confirmation modal cancel fn
    const roleDeleteCancleButton = () => {
        setDeleteRoleModalFlag(false);
        setRoleDeleteBodySecondContent("")
    }

    //delete role confirmation modal confirm button click fn
    const roleDeleteConfirmButton = () => {
        roleDeleteApi()
    }

    //role delete api fn
    const roleDeleteApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        let data = {}
        data['id'] = [roleDeleteObj.id]
        roleDelete(data).then((response) => {
            if (response.success) {
                resetDataGrid()
                deleteRoleConfirmationModalHide()
                Utility.toastNotifications(response.data[0].message, "Success", "success")
            } else {
                Utility.toastNotifications(response.data[0].message, "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
            deleteRoleConfirmationModalHide()
        });

    }

    //role form validate
    const validationRoleFromData = () => {
        let valid = true;

        let tempRoleName = roleName;
        let trimmedRoleName = tempRoleName.trim();
        if (trimmedRoleName == '') {
            valid = false;
            setRoleNameError("Required Field")
        }
        if (Object.keys(selectedBranch).length == 0) {
            valid = false;
            setBranchNameError("Required Field")
        }

        const { storeDetails, orgDetails } = storeOrgDetails();

        if (transformData(roleRawData, storeDetails, orgDetails).length == 0) {
            valid = false;
            Utility.toastNotifications("Please choose at least one role to proceed", "Warning", "warning")
        }

        return valid
    }

    const storeOrgDetails = () => {
        let storeDetails = storeData ? { "store_type": storeData.store_type, "is_procurement_hub": storeData.is_procurement_hub, "can_sell": storeData.can_sell } : currentStore ? { "store_type": currentStore.store_type, "is_procurement_hub": currentStore.is_procurement_hub, "can_sell": currentStore.can_sell } : { "store_type": null, "is_procurement_hub": false, "can_sell": false };
        const orgDetails = storeData?.orgMetaStoreRelation ? { "allow_main_store": storeData.orgMetaStoreRelation.allow_main_store } : currentStore?.orgMetaStoreRelation ? { "allow_main_store": currentStore.orgMetaStoreRelation.allow_main_store } : { "allow_main_store": false };

        return { storeDetails, orgDetails };
        
    }

    //role data formatting fn
    const formatingRoleDataset = () => {
        let dataset = [];
        let hash = {}
        hash["name"] = roleName;
        // hash["role_json"] = transformData(roleRawData);
        const { storeDetails, orgDetails } = storeOrgDetails();
        hash["role_json"] = transformData(roleRawData, storeDetails, orgDetails);
        if (!editedFlag) {
            hash["is_active"] = true;
        }
        hash["branch_id"] = selectedBranch.value;
        dataset.push(hash)
        return dataset;
    }

    //role data save api fn
    const roleDataSave = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let vaildData = validationRoleFromData();
        if (vaildData) {
            let dataSet = formatingRoleDataset();
            let id = "";
            let type = 'post';
            if (editedFlag) {
                id = editedId;
                type = "patch";
                dataSet = dataSet[0];
            }
            loaderStateTrue();
            roleCreate(dataSet, id, type).then((response) => {
                if (type == "post") {
                    if (response.length > 0) {
                        response.map((data) => {
                            if (data.success) {
                                resetDataGrid();
                                closeRoleModal();
                                Utility.toastNotifications(data.message, "Success", "success")
                            } else {
                                resetDataGrid();
                                props.loaderStateFalse();
                                Utility.toastNotifications(data.message, "Error", "error")
                            }
                        })
                    }
                } else {
                    if (response.success) {

                        closeRoleModal();
                        resetDataGrid();
                        Utility.toastNotifications(response.message, "Success", "success");
                        loaderStateFalse();
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error")
                        loaderStateFalse();
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();
            });
        }
    }

    //role menu selected onchange fn
    const menuSelected = (e, obj, type) => {
        let tempRoleData = [...roleRawData];

        tempRoleData.forEach((value, idx) => {
            if (obj.eventKey === value.eventKey) {
                if (type === 'C') {
                    value['crud'] = e.target.checked;
                    value['read'] = e.target.checked;
                    value['write'] = e.target.checked;

                    if (value['subeventKey']) {
                        value['subeventKey'].forEach(subValue => {
                            subValue['read'] = e.target.checked;
                            subValue['write'] = e.target.checked;
                            subValue['crud'] = e.target.checked;
                            if (subValue.actions) {
                                Object.keys(subValue.actions).forEach(actionKey => {
                                    if (typeof subValue.actions[actionKey] === 'boolean') {
                                        subValue.actions[actionKey] = e.target.checked;
                                    }
                                });
                            }
                        });
                    }
                }

                if (type === 'R') {
                    value['read'] = e.target.checked;
                    if (value['write'] && e.target.checked) {
                        value['crud'] = true;
                        if (value['subeventKey']) {
                            value['subeventKey'].forEach(subValue => {
                                subValue['crud'] = true;
                            });
                        }
                    } else {
                        value['crud'] = false;
                        if (value['subeventKey']) {
                            value['subeventKey'].forEach(subValue => {
                                subValue['crud'] = false;
                            });
                        }
                    }

                    // Update subeventKey read based on eventKey read
                    if (value['subeventKey']) {
                        value['subeventKey'].forEach(subValue => {
                            subValue['read'] = e.target.checked;
                        });
                    }
                }

                if (type === 'W') {
                    value['write'] = e.target.checked;
                    if (value['read'] && e.target.checked) {
                        value['crud'] = true;
                        if (value['subeventKey']) {
                            value['subeventKey'].forEach(subValue => {
                                subValue['crud'] = true;
                            });
                        }
                    } else {
                        value['crud'] = false;
                        if (value['subeventKey']) {
                            value['subeventKey'].forEach(subValue => {
                                subValue['crud'] = false;
                            });
                        }
                    }
                    if (value['subeventKey']) {
                        value['subeventKey'].forEach(subValue => {
                            subValue['write'] = e.target.checked;
                            if (subValue.actions) {
                                Object.keys(subValue.actions).forEach(actionKey => {
                                    if (typeof subValue.actions[actionKey] === 'boolean') {
                                        subValue.actions[actionKey] = e.target.checked;
                                    }
                                });
                            }
                        });
                    }
                }
            }
        });

        setroleRawData(tempRoleData);
    };

    //role sub menu selected onchange fn
    const submenuSelected = (e, obj, type) => {
        let tempRoleData = [...roleRawData];

        tempRoleData.forEach((event) => {
            if (event?.subeventKey && event.subeventKey.length > 0) {
                event.subeventKey.forEach((subEvent) => {
                    if (subEvent.eventKey === obj.eventKey) {
                        // Update subevent properties based on the type
                        if (type === 'C') {
                            subEvent['crud'] = e.target.checked;
                            subEvent['read'] = e.target.checked;
                            subEvent['write'] = e.target.checked;
                            if (subEvent.actions) {
                                Object.keys(subEvent.actions).forEach(actionKey => {
                                    if (typeof subEvent.actions[actionKey] === 'boolean') {
                                        subEvent.actions[actionKey] = e.target.checked;
                                    }
                                });
                            }
                        } else if (type === 'R') {
                            subEvent['read'] = e.target.checked;
                            subEvent['crud'] = subEvent['read'] && subEvent['write'];
                        } else if (type === 'W') {
                            subEvent['write'] = e.target.checked;
                            subEvent['crud'] = subEvent['read'] && subEvent['write'];
                            if (subEvent.actions) {
                                Object.keys(subEvent.actions).forEach(actionKey => {
                                    if (typeof subEvent.actions[actionKey] === 'boolean') {
                                        subEvent.actions[actionKey] = e.target.checked;
                                    }
                                });
                            }
                        }

                        const subeventSelected = event.subeventKey.some(sub => sub['crud']);
                        event['crud'] = subeventSelected;
                        event['read'] = subeventSelected || event.subeventKey.some(sub => sub['read']);
                        event['write'] = subeventSelected || event.subeventKey.some(sub => sub['write']);
                    }
                });
            }
        });

        setroleRawData(tempRoleData);
    };

    //role action selected onchange fn
    const actionSelected = (e, obj, actionType) => {
        let tempRoleData = [...roleRawData];

        tempRoleData.forEach((event) => {
            if (event?.subeventKey && event.subeventKey.length > 0) {
                event.subeventKey.forEach((subEvent) => {
                    if (subEvent.eventKey === obj.eventKey && subEvent.actions) {
                        // Update the specific action
                        subEvent.actions[actionType] = e.target.checked;

                        // Check if any action is true
                        const anyActionChecked = Object.keys(subEvent.actions).some(
                            key => typeof subEvent.actions[key] === 'boolean' && subEvent.actions[key]
                        );

                        // If any action is checked, automatically check write
                        if (anyActionChecked) {
                            subEvent['write'] = true;
                            // If read is also true, set crud to true
                            if (subEvent['read']) {
                                subEvent['crud'] = true;
                            }
                        } else {
                            // If all actions are unchecked, uncheck write and crud
                            subEvent['write'] = false;
                            subEvent['crud'] = false;
                        }
                    }
                });
                const subeventSelected = event.subeventKey.some(sub => sub['crud']);
                event['crud'] = subeventSelected;
                event['write'] = subeventSelected || event.subeventKey.some(sub => sub['write']);
            }
        });

        setroleRawData(tempRoleData);
    };

    //role data formatting for role save fn
    /*const transformData = (inputData) => {
        let output = [];

        inputData.forEach(event => {
            const eventObject = {
                eventKey: event.eventKey,
                rules: ''
            };
            if (event.crud) {
                eventObject.rules += 'CRUD';
            } else {
                if (event.read) {
                    eventObject.rules += 'R';
                }
                if (event.write) {
                    eventObject.rules += 'CUD';
                }
            }
            if (event.subeventKey && event.subeventKey.length > 0) {
                eventObject.subeventKey = event.subeventKey.map(subevent => {
                    const subeventObject = {
                        eventKey: subevent.eventKey,
                        rules: ''
                    };
                    if (subevent.crud) {
                        subeventObject.rules += 'CRUD';
                    } else {
                        if (subevent.read) {
                            subeventObject.rules += 'R';
                        }
                        if (subevent.write) {
                            subeventObject.rules += 'CUD';
                        }
                    }

                    // Add actions for all subeventKeys
                    if (subevent.actions) {
                        subeventObject.actions = { ...subevent.actions };
                    }

                    return subeventObject;
                });
            }
            if (eventObject.rules !== '') {
                output.push(eventObject);
            }
        });

        return output;
    }*/

    const transformData = (inputData, storeDetails, orgDetails) => {
        return inputData.map(event => {
            const isEligible = IsEligibleToShow(
                event.eventKey,
                storeDetails,
                orgDetails
            );

            const eventObject = {
                eventKey: event.eventKey,
                rules: ''
            };

            // Only assign rules if eligible
            if (isEligible) {
                if (event.crud) {
                    eventObject.rules = 'CRUD';
                } else {
                    if (event.read) eventObject.rules += 'R';
                    if (event.write) eventObject.rules += 'CUD';
                }
            }

            if (event.subeventKey?.length > 0) {
                eventObject.subeventKey = event.subeventKey.map(subevent => {
                    const isSubEligible = IsEligibleToShow(
                        subevent.eventKey,
                        storeDetails,
                        orgDetails
                    );

                    const subeventObject = {
                        eventKey: subevent.eventKey,
                        rules: ''
                    };

                    if (isSubEligible) {
                        if (subevent.crud) {
                            subeventObject.rules = 'CRUD';
                        } else {
                            if (subevent.read) subeventObject.rules += 'R';
                            if (subevent.write) subeventObject.rules += 'CUD';
                        }
                    }

                    if (subevent.actions) {
                        subeventObject.actions = {};
                        Object.keys(subevent.actions).forEach(actionKey => {
                            if (IsEligibleToShow(actionKey, storeDetails, orgDetails)) {
                                subeventObject.actions[actionKey] = subevent.actions[actionKey];
                            }
                        });
                    }

                    return subeventObject;
                });
            }

            return eventObject;
        });
    };

    //handle role data change from templates
    const handleRoleDataChange = (newRoleData) => {
        setroleRawData(newRoleData);
    };

    //role form input onchange fn
    const handelChange = (e, type) => {
        if (type == "role_name") {
            var expr = /^[a-zA-Z0-9 ]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                if (e.target.value == "") {
                    setRoleName("")
                    setRoleNameError("")
                } else {
                    setRoleName(e.target.value)
                    setRoleNameError("")
                }
            }
        }

        if (type == "branch_name") {
            if (e != "") {
                setSelectedBranch(e);
                setBranchNameError("");
            } else {
                setSelectedBranch({});
                setBranchNameError("");
            }
        }
    }

    //Modal Zoom in fn
    const zoominFunction = () => {
        let zoominzoomoutflag = "zoominzoomoutclassDialog"
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //Modal Zoom out fn
    const zoomoutFunction = () => {
        let zoominzoomoutflag = ""
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //status and branch filter onchange fn
    const handleChangeRoleFilter = (type, event) => {
        if (type == 'status') {
            if (event) {
                setSelectedStatus(event)
            } else {
                setSelectedStatus("")
            }
        }
        if (type == 'branch') {
            if (event) {
                setHotelBranchFilterSelectedValue(event)
            } else {
                setHotelBranchFilterSelectedValue("")
            }
        }
    }

    //when status change role grid reset
    useEffect(() => {
        if (gridApi && selectedStatus != "" && selectedStatus.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && selectedStatus == "") {
            resetDataGrid();
        }
    }, [selectedStatus])

    //role search field onchange fn
    const handleSearchValue = (e) => {
        setSearchRole(e.target.value)
    }

    //when search value change role grid reset
    useEffect(() => {
        if (searchRole != "") {
            resetDataGrid()
        }
        if (searchRole.length == 0 && gridparams) {
            resetDataGrid()
        }
    }, [searchRole])

    //when search value clear fn
    const clearSearchValue = () => {
        setSearchRole("")
    }

    //initially fetch hotel branch list
    useEffect(() => {
        if (roleRef.current) {
            roleRef.current = false;
            hotelBranchFilterListApi()
        }
    }, [])

    //get hotel branch list api fn
    const hotelBranchFilterListApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {};
        loaderStateTrue();
        // getHotelBranchList(data).then((response) => {
        //     let hotelBranchResponse = Object.keys(response.data).length > 0 && response.data[Object.keys(response.data)[0]]?.OrgBranchOrgRelation.length > 0 ? response.data[Object.keys(response.data)[0]].OrgBranchOrgRelation : {}
        //     let branchListData = [];
        //     let branchListObj = {};
        //     hotelBranchResponse.map((e) => {
        //         branchListObj = {};
        //         // branchListObj['label'] = `${e.branch_name}`;
        //         branchListObj['label'] = `${e.name}`;
        //         branchListObj['value'] = e.id;
        //         branchListData.push(branchListObj)
        //     })
        //     if (branchListData.length > 0) {
        //         setBranchFilterList(branchListData);
        //     }

        //     loaderStateFalse();
        // }).catch((error) => {
        //     loaderStateFalse();

        // });

        let filters = {};
        let userType = props.userCredentials.user_details.user_type;
        getStoreList(filters, userType, "", props.currentStore?.slack).then((response) => {
            let hotelBranchResponse = response.data || [];
            let branchListData = [];
            let branchListObj = {};
            hotelBranchResponse.map((e) => {
                branchListObj = {};
                branchListObj['label'] = `${e.name}`;
                branchListObj['value'] = e.id;
                branchListData.push(branchListObj)
            })
            console.log("branchListData", branchListData)
            if (branchListData.length > 0) {
                setBranchFilterList(branchListData);
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();

        });
    }

    //when branch filter change role grid reset
    useEffect(() => {
        if (gridApi && hotelBranchFilterSelectedValue != "" && hotelBranchFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && hotelBranchFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [hotelBranchFilterSelectedValue])

    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    //role grid reload fn

    const loadGrid = () => {
        resetDataGrid();
    }

    return (
        <div>
            <div className="gridcontainer roleGridContainer">
                <div className="totalworkercontentBox">
                    <div className="gridtopviews gridtopviewsHistory gridtopviewsAllSectionBox">
                        <div className="rightboxesSec">
                            {Utility.getRoleObjectBySubEventKey('user_and_customer', 'roles').length > 0 && (Utility.getRoleObjectBySubEventKey('user_and_customer', 'roles')[0].rules == "CRUD" || Utility.getRoleObjectBySubEventKey('user_and_customer', 'roles')[0].rules == "CUD") && rolePermissions.create &&
                                <CustomButton
                                    onClick={createRoleModalFn}
                                    className="customButtonClassBox"
                                    children="Add Role"
                                />
                            }
                        </div>
                    </div>
                    <div className='filterSectionBox'>
                        <div className="gridtopviews gridtopviewsHistory">
                            <div className="dropdownBoxContainer statusdropcontainerBox">
                                <AutosuggestComponent
                                    handleOnChange={(e) => { handleChangeRoleFilter('status', e) }}
                                    options={statusList}
                                    selectedValue={selectedStatus}
                                    name=''
                                    isMulti={false}
                                    placeholder="Status"
                                    isDisabled={false}
                                    isClearable={true}
                                    closeButton={true}
                                    menuHeader="Status"
                                    isSearchable={true}
                                />
                            </div>
                            <div className="dropdownBoxContainer  branchDropdownBox">
                                <AutosuggestComponent
                                    handleOnChange={(e) => { handleChangeRoleFilter('branch', e) }}
                                    options={branchFilterList}
                                    selectedValue={hotelBranchFilterSelectedValue}
                                    name=''
                                    isMulti={false}
                                    placeholder="Store"
                                    isDisabled={false}
                                    isClearable={true}
                                    closeButton={false}
                                    menuHeader="Branch"
                                    isSearchable={true}

                                />
                            </div>
                            <form id="role">
                                <div className="pageinnersearchBox">
                                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                                    <DebounceInput
                                        minLength={2}
                                        debounceTimeout={500}
                                        onChange={(e) => handleSearchValue(e)}
                                        placeholder="Search role name"
                                        value={searchRole}
                                        autoComplete="off"
                                    />
                                    {searchRole != "" ?
                                        < button type="button" className="btn btn-link dropclosebtn"
                                            onClick={clearSearchValue}
                                        >
                                            <img src={require('../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                                        </button>
                                        : null}
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className='grid_content_inner'>
                        <div className="ag-theme-alpine aggridviewSection" style={{ position: 'relative' }}>
                            <div className="leadButtonInnerBox"><button className="buttonload" onClick={() => { loadGrid() }} data-tip="Refresh"><RefreshButton
                                isAnimating={isAnimating}
                            />
                            </button>
                                <ReactTooltip place="bottom" />
                            </div>
                            <AgGridReact
                                modules={modules}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                components={components}
                                rowSelection="single"
                                rowModelType="infinite"
                                onGridReady={onGridReady}
                                rowHeight={43.9}
                                headerHeight={40.8}
                                cacheBlockSize={process.env.PAGE_DATA_LIMIT}
                                gridOptions={gridOptions}
                                noRowsOverlayComponent={noRowsOverlayComponent}
                                ref={gridRef}
                            />
                        </div>
                    </div>
                </div>
                {actionModalflag ?
                    <>
                        <ErrorBoundary title="GridActionContent Error">
                            <GridActionContent
                                styleWidth={overlayWidth}
                                styleHight={overlayHight}
                                codeOutsideClickRef={actionOutsideClickRef}
                                gridObjData={gridObjData}
                                roleManagePermissionFn={editRoleManagePermissionFn}
                                delete={deleteRole}
                                archivedButtonShow={false}
                                editButtonShow={false}
                                deleteButtonShow={Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0 && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].eventKey == "roles" && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].rules == "CUD")) && rolePermissions.delete ? true : false}
                                roleManagePermissionButtonShow={Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0 && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].eventKey == "roles" && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[2].rules == "CUD")) && rolePermissions.manage_permissions ? true : false}
                            />
                        </ErrorBoundary>
                    </>
                    : null}

                {/* Role add edit modal */}
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={roleCreateModalFlag}
                        onHide={closeRoleModal}
                        title={editedFlag ? "Edit Role" : "New Role"}
                        className={` ${zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension rolModalDialogContent"}`}
                        footer={false}
                        closeButton={true}
                        saveButtonLabel="Confirm"
                        saveButtonClassName="btn btn-primary savebtn"
                        cancelShow={true}
                        zoominButton={zoominzoomoutflag != "" ? false : true}
                        zoomoutButton={zoominzoomoutflag != "" ? true : false}
                        zoomin={zoominFunction}
                        zoomout={zoomoutFunction}
                        body={
                            <ErrorBoundary title="RoleAddEditModalContent Error">
                                <RoleAddEditModalContent
                                    roleDataSave={roleDataSave}
                                    closeRoleModal={closeRoleModal}
                                    roleRawData={roleRawData}
                                    menuSelected={menuSelected}
                                    submenuSelected={submenuSelected}
                                    actionSelected={actionSelected}
                                    handelChange={handelChange}
                                    roleName={roleName}
                                    editedFlag={editedFlag}
                                    branchList={branchList}
                                    selectedBranch={selectedBranch}
                                    roleNameError={roleNameError}
                                    branchNameError={branchNameError}
                                    onRoleDataChange={handleRoleDataChange}
                                    storeData={storeData}
                                />
                            </ErrorBoundary>
                        }
                    />
                </ErrorBoundary>

                {/* Role delete confirmation modal */}
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={deleteRoleModalFlag}
                        onHide={deleteRoleConfirmationModalHide}
                        className="modalcustomizeDialog confirmationalertmodalDialog"
                        bodyClassName="cancelConfirmationbody"
                        headerclassName="close_btn_icon"
                        title="Delete This Role?"
                        footer={false}
                        body={
                            <>
                                <ErrorBoundary title="ConfirmationAlert Error">
                                    <ConfirmationAlert
                                        BodyFirstContent="Do you confirm the deletion of the"
                                        BodySecondContent={
                                            roleDeleteBodySecondContent.length >= 20 ? roleDeleteBodySecondContent.substring(0, 20) + "..." : roleDeleteBodySecondContent}
                                        BodyThirdContent="role definitely? You won't be able to go back."
                                        confirmationButtonContent="Confirm"
                                        cancelButtonContent="Cancel"
                                        deleteConfirmButton={roleDeleteConfirmButton}
                                        deleteCancleButton={roleDeleteCancleButton}
                                        deleteIconVissable={true}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
            </div>
        </div>
    );

}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        currentStore: globalState.StoreReducer.currentStore
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })((Role));